import { FedopsLogger } from '@wix/fedops-logger'
import { tryCatch } from '@wix/funnel-utils'

import { interactions } from '../../../fedops.json'
import { reportError } from '../reportError'

type OperationName = keyof typeof interactions

export default (fedopsLogger: FedopsLogger) => {
  return async <TResult>(operation: () => Promise<TResult>, operationName: OperationName) => {
    fedopsLogger.interactionStarted(operationName)
    const [error, result] = await tryCatch(operation)
    if (error) {
      reportError(error, { operationName })
      throw error
    }
    fedopsLogger.interactionEnded(operationName)
    return result
  }
}
